import './assets/scss/main.scss';

// import { BaseStore } from '@/store/base.store';
import * as components from './components';
import * as layouts from './layouts';

function plugin(Vue, { store }) {
  if (!store) {
    throw new Error('Please provide vuex store.');
  }

  // store.registerModule('base', BaseStore);

  // eslint-disable-next-line no-restricted-syntax
  for (const key in components) {
    const component: typeof Vue = (components as any)[key];
    if (component) {
      Vue.component(key, component);
    }
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const key in layouts) {
    const layout: typeof Vue = (layouts as any)[key];
    if (layout) {
      Vue.component(key, layout);
    }
  }
}

if (typeof window !== 'undefined' && (window as any).Vue) {
  (window as any).Vue.use(plugin);
}

export default plugin;
